import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const getUserModerationSummary = async (userId) => {

  try {
    const { data } = await axiosInstance.get(`reports/moderation-summary/${userId}`);
    return data|| null;
  } catch (error) {
    console.error(`Error fetching user moderation summary for user ID ${userId}:`, error);
    return null;
  }
};


export const useUserModerationSummary = (userId) => {
  return useQuery({
    queryKey: ["userModerationSummary", userId],
    queryFn: () => getUserModerationSummary(userId),
    enabled: !!userId, 
    staleTime: 1000 * 60 * 5, 
  });
};

export default useUserModerationSummary 

